export * from './StrapiTradeAdvantagesWidget'
